import { gql } from '@apollo/client';

export default gql`
  query GetAcademyCourseInvoices($courseId: String!) {
    invoices(courseId: $courseId)
      @rest(
        type: "CourseInvoice"
        path: "academy/courses/{args.courseId}/invoices"
      ) {
      _id
      course
      coursePeriodDateEnd
      coursePeriodDateInit
      paid
    }
  }
`;
